import { useEffect } from 'react';

export const usePageTitle = (title?: string, baseTitle = 'Physna') => {
  useEffect(() => {
    const fullTitle = title ? `${title} - ${baseTitle}` : baseTitle;
    document.title = fullTitle;

    return () => {
      document.title = baseTitle;
    };
  }, [title, baseTitle]);
};
